export const getDateWithoutTime = (dateStart) => {
  const date = new Date(dateStart);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const dateString = `${day}.${month}.${year}.`;
  return dateString;
};